var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.scacMajor === 10)?_c('div',{class:_vm.$style.scacDescription},[_c('v-text-field',{class:_vm.messageClass,attrs:{"value":_vm.scacDescription,"outlined":"","disabled":_vm.disabled,"label":_vm.$t('SCAC_DESCRIPTION'),"messages":_vm.message},on:{"keyup":_vm.onKeyUp}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }